module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cartTotals":"Cart totals","subtotal":"Subtotal","shipping":"Shipping","salesTax":"Sales Tax","total":"Total","discount":"Discount","checkout":"Checkout"},"de":{"subtotal":"Zwischensumme","shipping":"Versand","salesTax":"MwSt.","total":"Gesamtpreis","discount":"Rabatt","checkout":"Zur Kasse"}}')
  delete Component.options._Ctor
}
